namespace TabAurous.Administration {
    export interface SendCampaignDetailsForm {
        ScheduleId: Serenity.StringEditor;
        PartyId: Serenity.StringEditor;
    }

    export class SendCampaignDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.SendCampaignDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SendCampaignDetailsForm.init)  {
                SendCampaignDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(SendCampaignDetailsForm, [
                    'ScheduleId', w0,
                    'PartyId', w0
                ]);
            }
        }
    }
}
